import type React from 'react';

interface MoneyBillIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function MoneyBillIcon({ size = 24, ...props }: MoneyBillIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.75C3.66848 5.75 3.35054 5.8817 3.11612 6.11612C2.8817 6.35054 2.75 6.66848 2.75 7V8.16229C3.33143 8.02438 3.86866 7.72753 4.2981 7.2981C4.72753 6.86866 5.02438 6.33143 5.16229 5.75H4ZM4 4.25C3.27065 4.25 2.57118 4.53973 2.05546 5.05546C1.53973 5.57118 1.25 6.27065 1.25 7V17C1.25 17.7293 1.53973 18.4288 2.05546 18.9445C2.57118 19.4603 3.27065 19.75 4 19.75H20C20.7293 19.75 21.4288 19.4603 21.9445 18.9445C22.4603 18.4288 22.75 17.7293 22.75 17V7C22.75 6.27066 22.4603 5.57118 21.9445 5.05546C21.4288 4.53973 20.7293 4.25 20 4.25H4ZM6.69044 5.75C6.53344 6.73188 6.0708 7.64671 5.35876 8.35876C4.64671 9.0708 3.73188 9.53344 2.75 9.69044V17C2.75 17.3315 2.8817 17.6495 3.11612 17.8839C3.35054 18.1183 3.66848 18.25 4 18.25H17.3096C17.4666 17.2681 17.9292 16.3533 18.6412 15.6412C19.3533 14.9292 20.2681 14.4666 21.25 14.3096V7C21.25 6.66848 21.1183 6.35054 20.8839 6.11612C20.6495 5.8817 20.3315 5.75 20 5.75H6.69044ZM21.25 15.8377C20.6686 15.9756 20.1313 16.2725 19.7019 16.7019C19.2725 17.1313 18.9756 17.6686 18.8377 18.25H20C20.3315 18.25 20.6495 18.1183 20.8839 17.8839C21.1183 17.6495 21.25 17.3315 21.25 17V15.8377ZM12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75ZM8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
